export default __webpack_public_path__ + "static/media/lightning-storm.b4845ac1.gif";